import axios from 'axios'

export const setCustomVehicleWeight = ({ reservationId, seqNum, sailRefId, weight }) =>
  axios.put(`api/weight/${reservationId}?seqNum=${seqNum}&sailRefId=${sailRefId}`, {
    weight,
  })

export const resetCustomVehicleWeight = ({ reservationId, seqNum, sailRefId }) =>
  axios.delete(`api/weight/${reservationId}?seqNum=${seqNum}&sailRefId=${sailRefId}`)
